import { get, set } from 'money-clip'
import ms from 'milliseconds'
import FullPage from '../components/full-page.svelte'
import SlideOne from '../components/home-slides/slide-one.svelte'
import SlideTwo from '../components/home-slides/slide-two.svelte'
import SlideThree from '../components/home-slides/slide-three.svelte'
import SlideFour from '../components/home-slides/slide-four.svelte'

const { $ } = window

export default {
	init() {
		let $homeApp = $('#home_app')
		let slides = $homeApp.data('slides')
		get('hideIntro', {
			// version: Math.random(),
			maxAge: ms.hours(1),
		}).then((hideIntro) => {
			new FullPage({
				target: document.querySelector('#main_content'),
				props: { hideIntro },
			})
			new SlideOne({
				target: document.getElementById('slide_1'),
				intro: true,
				props: { hideIntro, fields: slides[0] },
			})
			new SlideTwo({
				target: document.getElementById('slide_2'),
				intro: true,
				props: { fields: slides[1] },
			})
			new SlideThree({
				target: document.getElementById('slide_3'),
				intro: true,
				props: { fields: slides[2] },
			})
			new SlideFour({
				target: document.getElementById('slide_4'),
				intro: true,
				props: {
					fields: slides[3],
				},
			})
			if (!hideIntro) {
				set('hideIntro', true)
			}
		})
	},
	finalize() {},
}
